import { Component, OnInit } from '@angular/core';
import { NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { ReportService } from 'src/app/services/report.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-km-report',
  templateUrl: './km-report.component.html',
  styleUrls: ['./km-report.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class KmReportComponent implements OnInit {

  date1:Date = new Date();
  date2:Date = new Date();
  data = [];
  loading:boolean = false;
  total:number = 0;
  closed:boolean = true;
  expand:boolean = false;

  constructor(private repServ:ReportService) { }

  ngOnInit() {
  }

  search() {
    this.loading = true;
    this.repServ.kmReport(this.date1, this.date2, this.closed).then(resp => {
      this.data = resp;
      this.total = this.data.map(t => Number(t.meters)).reduce((ant, act) => ant + act, 0);
      this.loading = false;
    });
  }

  download(type) {
    window.open(environment.baseUrl + '/' + type + '/km?date1=' + this.date1.toString() + '&date2=' + this.date2.toString() + '&closed=' + this.closed, '_blank')
  }
}
